import PaymentScheduleScreen from 'features/payOverTime/screens/PaymentSchedule/PaymentSchedule';
import React from 'react';

export default function Page() {
  return <PaymentScheduleScreen />;
}
